import { render, staticRenderFns } from "./DownloadResults.vue?vue&type=template&id=3e49aca2&scoped=true&"
import script from "./DownloadResults.vue?vue&type=script&lang=js&"
export * from "./DownloadResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e49aca2",
  null
  
)

export default component.exports